import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { guid } from "@pcp/core/interfaces";
import { ActiveLessonInfo } from "./classroomState";


export const lessonEvents = createActionGroup({
    source: 'LessonEvents',
    events: {
        reconnectAfterLessonStateRestoreSuccess: emptyProps(),
        reconnectAfterLessonStateRestoreFailed: emptyProps(),
    }
});


export const lessonActionsOpenScreen = createActionGroup({
    source: 'LessonOpenScreen',
    events: {
        openAdditionalBeamerScreen: emptyProps(),
        additionalBeamerScreenOpenedSuccessfully: emptyProps(),
        openAdditionalBeamerScreenFailed: props<{ error: string }>(),
    }
});

export const restoreLessonActions = createActionGroup({
    source: 'LessonRestore',
    events: {
        restoreLessonStateSuccess: props<{ lesson: ActiveLessonInfo, lessonType: 'Lesson' | 'LiveLesson' }>(),
        restoreLessonStateFailed: props<{ error: any }>(),
    }
});

export const startLessonActions = createActionGroup({
    source: 'LessonStart',
    events: {
        startLesson: emptyProps(),
        /**
         * Lesson started, SignalR connection established and beamer code retrieved.
         */
        startLessonSuccess: props<{ lesson: ActiveLessonInfo, lessonCode: string }>(),
        startLessonFailed: props<{ error: any }>(),

        /**
         * Before starting a lesson, a lesson code must be requested
         * in order to open a beamer screen.
         */
        requestLessonCodeSuccess: props<{ lessonCode: string, studentRegistrationCode: string }>(),

        /** Lesson started and the beamer screen was automatically opened. */
        lessonStartedAndBeamerWasAutomaticallyOpened: props<{ openedOnWindowId: string }>(),

        /** Lesson started. The beamer screen could not be automatically opened and a connection info modal was shown to the user. */
        lessonStarted_connectionInfoModalWasShown: emptyProps(),
    }
});

export const stopLessonActions = createActionGroup({
    source: 'LessonStop',
    events: {
        stopLesson: emptyProps(),
        stopLessonFailed: props<{ error: any }>(),
        /**
         * This teacher client's local stop chain ran to completion — the
         * completion marker at the teacher-process → classroom-lifecycle
         * boundary, translated into `lessonHasBeenStopped` by
         * `ClassroomLifecycleEffects`. It claims nothing beyond that: not that
         * the beamer window closed (best-effort, never verified), not that
         * consumers disconnected (they are notified, nothing confirms they
         * acted), not that the lesson stopped server-side (that happened at the
         * REST call before this).
         */
        stopLesson_disconnectedFromClassroom: emptyProps(),
        confirmStopLesson: props<{ lessonId: guid }>(),
        confirmStopLessonContinue: props<{ lessonId: guid }>(),
        confirmStopLessonCancel: emptyProps(),
        postLessonStopToWebApi: emptyProps(),
        postLessonStopToWebApiSuccess: emptyProps(),
        postLessonStopToWebApiFailed: props<{ error: any }>(),
        /** Teacher has entered the lesson-stop registration flow — synced to beamer via Yjs. */
        beginLessonStop: emptyProps(),
        /** Teacher has completed the lesson-stop registration flow — synced to beamer via Yjs. */
        endLessonStop: emptyProps(),
    }
});


export const pauseLessonActions = createActionGroup({
    source: 'LessonPause',
    events: {
        pauseLesson: emptyProps(),
        resumeLesson: emptyProps(),
    }
});
